export const getIsAcceptanceTest = () => {
  try {
    return document.cookie.includes('hs_selenium');
  } catch (error) {
    return false;
  }
};